import { atom, useAtom } from 'jotai/index';
import { atomWithStorage } from 'jotai/utils';
import { IClaimMultiSignWallet } from 'types';

export const safesAtom = atom<IClaimMultiSignWallet[]>([]);
export const safesLoadingAtom = atom<boolean>(true);

export const useSafes = () => {
  const [safes, setSafes] = useAtom(safesAtom);
  const [isSafesLoading, setIsSafesLoading] = useAtom(safesLoadingAtom);

  return {
    isSafesLoading,
    setIsSafesLoading,
    safes,
    setSafes,
  };
};

const selectedSubaccountsAtom = atomWithStorage<Array<{ parentId: string; selectedId: string }>>(
  'subaccounts',
  []
);

export const useSelectedSubAccounts = () => {
  const [selectedSubaccounts, setSelectedSubaccounts] = useAtom(selectedSubaccountsAtom);

  const selectSubAccount = (parentId: string, selectedId: string) => {
    if (parentId === selectedId) {
      setSelectedSubaccounts(selectedSubaccounts?.filter((acc) => acc.parentId !== parentId));
    } else {
      const index = selectedSubaccounts?.findIndex((elem) => elem.parentId === parentId);
      const newData = [...selectedSubaccounts];
      if (index >= 0) {
        newData[index].selectedId = selectedId;
      } else {
        newData.push({ parentId, selectedId });
      }
      setSelectedSubaccounts(newData);
    }
  };

  return {
    selectedSubaccounts,
    selectSubAccount,
  };
};

export const useSubAccountForSafe = (safeId: string) => {
  const { selectedSubaccounts } = useSelectedSubAccounts();

  return selectedSubaccounts.find((acc) => acc.parentId === safeId)?.selectedId || safeId;
};
